// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"49":"join","177":"home","443":"about"}[chunkId] + "-legacy." + {"49":"bf59a1d5","177":"39efb5dd","443":"82ae6e8e"}[chunkId] + ".js";
};